'use client';
import React, { useState } from 'react';
import GemDuelGame from './GemDuelGame';

interface GemDuelWrapperProps {
  onClose: () => void;
}

export default function GemDuelWrapper({ onClose }: GemDuelWrapperProps) {
  const [result, setResult] = useState<'playing' | 'won' | 'lost'>('playing');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', minHeight: 520 }}>
      {result === 'playing' && (
        <GemDuelGame
          onWin={() => setResult('won')}
          onLose={() => setResult('lost')}
        />
      )}
      {result !== 'playing' && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 16, padding: 24, textAlign: 'center' }}>
          <div style={{ fontSize: 64 }}>{result === 'won' ? '🏆' : '💀'}</div>
          <h2 style={{ color: result === 'won' ? '#ffd23f' : '#ff3b6b', fontWeight: 900, fontSize: '1.5rem', margin: 0 }}>
            {result === 'won' ? 'You won the duel!' : 'The AI won this round'}
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.8rem', margin: 0 }}>
            {result === 'won' ? 'Stickers collected. Abilities unlocked.' : 'Match more gems next time.'}
          </p>
          <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
            <button
              onClick={() => setResult('playing')}
              style={{
                background: 'linear-gradient(135deg, #ffd23f, #ff9500)',
                border: 'none', borderRadius: 12, padding: '12px 24px',
                color: '#0a0a0f', fontWeight: 900, fontSize: '0.9rem', cursor: 'pointer',
              }}
            >
              ⚔️ Rematch
            </button>
            <button
              onClick={onClose}
              style={{
                background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: 12, padding: '12px 24px',
                color: 'rgba(255,255,255,0.7)', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer',
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
